'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notification = require('./Notification');

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Notification2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-notification/lib/index.js
 ** module id = 218
 ** module chunks = 0
 **/